import React from 'react';

const HelpModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto bg-slate-900/60 backdrop-blur-xs flex items-center justify-center p-4">
      <div className="fixed inset-0" onClick={onClose} />
      <div className="relative w-full max-w-lg bg-white rounded-2xl shadow-2xl border border-slate-200 overflow-hidden z-10 animate-fadeIn text-slate-800">
        <div className="p-4 px-5 border-b border-slate-100 bg-blue-600 text-white flex items-center justify-between">
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 rounded-xl bg-white/20 text-white flex items-center justify-center">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div>
              <h3 className="text-base font-bold text-white">Help & Documentation</h3>
              <p className="text-[11px] text-blue-100">NexDesk quick start guide & key shortcuts</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="w-7 h-7 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center text-xs"
          >
            ✕
          </button>
        </div>

        <div className="p-5 space-y-3.5 text-xs">
          <div className="space-y-2">
            <div className="p-3 rounded-xl bg-slate-50 border border-slate-200/80">
              <h5 className="font-bold text-slate-900 flex items-center gap-1.5 mb-1">
                <svg className="w-3.5 h-3.5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
                <span>Global Command Search</span>
              </h5>
              <p className="text-slate-500 text-[11px] leading-relaxed">
                Press <kbd className="px-1.5 py-0.5 bg-white border border-slate-300 rounded font-mono font-bold text-slate-700">⌘K</kbd> or <kbd className="px-1.5 py-0.5 bg-white border border-slate-300 rounded font-mono font-bold text-slate-700">Ctrl+K</kbd> anywhere in the application to search tickets, equipment, and serial numbers.
              </p>
            </div>

            <div className="p-3 rounded-xl bg-slate-50 border border-slate-200/80">
              <h5 className="font-bold text-slate-900 flex items-center gap-1.5 mb-1">
                <svg className="w-3.5 h-3.5 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z" />
                </svg>
                <span>Tickets & SLA Tracking</span>
              </h5>
              <p className="text-slate-500 text-[11px] leading-relaxed">
                Tickets transition through Open → In Progress → Closed statuses. All closures require a mandatory resolution note.
              </p>
            </div>

            <div className="p-3 rounded-xl bg-slate-50 border border-slate-200/80">
              <h5 className="font-bold text-slate-900 flex items-center gap-1.5 mb-1">
                <svg className="w-3.5 h-3.5 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <span>Hardware Asset Inventory</span>
              </h5>
              <p className="text-slate-500 text-[11px] leading-relaxed">
                Track laptops, desktops, and peripherals with serial numbers, assigned users, and photo attachments.
              </p>
            </div>
          </div>

          <div className="pt-2 text-center">
            <p className="text-[11px] text-slate-500">
              For dedicated support or custom enterprise integrations:
              <br />
              <a href="mailto:support@nexbond.in" className="text-blue-600 font-bold hover:underline">
                support@nexbond.in
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpModal;
